import axios from "axios";
import store from "../store";

import { authLogout } from "../modules/web/store/actions/actions-auth";

import config from "../config";

const API_URL = `${config.apiGateway.URL}`;

axios.defaults.baseURL = API_URL;
axios.defaults.headers.common.Accept = "application/json";

axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            store.dispatch(authLogout());
        }

        return Promise.reject(error.response);
    }
);

export default axios;
